import Image, { ImageProps } from 'next/image';
import { SVGProps } from 'react';
import { classes } from 'shared';

import { useEffect, useState } from 'react';
import { useWindowSize } from '../hooks/useWindowSize';

import charityNavigatorBadge from '../../assets/Charity_Navigator_Four_Star_Rating_Badge_Transparent_2026.svg';
import deliver from '../../assets/general/deliver.svg';
import donate from '../../assets/general/donate.svg';
import dream from '../../assets/general/dream.svg';
import instagram from '../../assets/general/instagram.svg';
import jumpingKid from '../../assets/general/jumping-kid.svg';
import hopeForHomes from '../../assets/hfh/hfh.svg';

export function InstagramIcon({ className }: { className?: string }) {
  return (
    <div className={classes(className, 'relative')}>
      <Image src={instagram} alt="instagram logo" className="max-w-full object-contain" />
    </div>
  );
}

export function BlueArch(props: SVGProps<SVGSVGElement>) {
  const [height, setHeight] = useState(0);
  const window = useWindowSize();

  useEffect(() => {
    const width = window.width;
    setHeight(Math.floor(width * (55 / 1600)) - 1);
  }, [window]);

  return (
    <div className="relative w-full" style={{ height: `${height}px` }}>
      <svg
        className="absolute bottom-0 left-0 right-0 top-0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1600 55"
        {...props}>
        <defs>
          <style>{'.blue-arch-1{fill:#0f004e;}'}</style>
        </defs>
        <path className="blue-arch-1" d="M1600,55H0v-3S400,2,800,2s800,50,800,50v3Z" />
      </svg>
    </div>
  );
}

export function WhiteArch(props: SVGProps<SVGSVGElement>) {
  const [height, setHeight] = useState(0);
  const window = useWindowSize();

  useEffect(() => {
    const width = window.width;
    setHeight(Math.floor(width * (55 / 1600)) + 1);
  }, [window]);

  return (
    <div className={classes('relative z-0 w-full', props.className)} style={{ height: `${height}px` }}>
      <svg
        {...props}
        className={classes('absolute -bottom-[1px]')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1600 55">
        <defs>
          <style>{'.white-arch-1{fill:#fff;}'}</style>
        </defs>
        <path className="white-arch-1" d="M1600,55H0v-3S400,2,800,2s800,50,800,50v3Z" />
      </svg>
    </div>
  );
}

export function InvertWhiteArch({
  ...props
}: { dRef?: React.MutableRefObject<SVGSVGElement> } & SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 175" {...props}>
      <defs>
        <style>{'.invert-white-arch-1{fill:#fff;}'}</style>
      </defs>
      <path className="invert-white-arch-1" d="M1600,0H0V175s400-50,800-50,800,50,800,50V0Z" />
    </svg>
  );
}

export function InvertBlueArch({
  ...props
}: { dRef?: React.MutableRefObject<SVGSVGElement> } & SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 175" {...props}>
      <defs>
        <style>{'.invert-blue-arch-1{fill:#0f004e;}'}</style>
      </defs>
      <path className="invert-blue-arch-1" d="M1600,0H0V175s400-50,800-50,800,50,800,50V0Z" />
    </svg>
  );
}

export function DonateStepImg({ className }: { className?: string }) {
  return <Image src={donate} alt="donate icon" className={className} />;
}

export function DeliverStepImg({ className }: { className?: string }) {
  return <Image src={deliver} alt="deliver icon" className={className} />;
}

export function DreamStepImg({ className }: { className?: string }) {
  return <Image src={dream} alt="dream icon" className={className} />;
}

export function JumpingKid(props: Omit<ImageProps, 'src' | 'alt'>) {
  return <Image src={jumpingKid} alt="" {...props} />;
}

export function XSVG(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
      <defs>
        <style>{'.x-icon-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:31px;}'}</style>
      </defs>
      <line className="x-icon-1" x1={18.5} y1={18.5} x2={493.5} y2={493.5} />
      <line className="x-icon-1" x1={18.5} y1={493.5} x2={493.5} y2={18.5} />
    </svg>
  );
}

export function HopeForHomes(props: Omit<ImageProps, 'src' | 'alt'>) {
  return <Image src={hopeForHomes} alt="Hope For Homes" {...props} />;
}

export function CharityNavigatorBadge(props: Omit<ImageProps, 'src' | 'alt'>) {
  return <Image src={charityNavigatorBadge} alt="Charity Navigator 4 Star Rating" {...props} />;
}
